import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import cogoToast from "cogo-toast";
import ListViewComponent from "../Patients/patientsListView";
import clarificationsService from "../../../../services/clarifications-service";
import VerbalOrderDetailItemComponent from "./components/verbal-order-details";
import VerifiedVerbalOrderListComponent from "./components/verified-verbal-orders-list";
import VERBAL_ORDERS_EMPTY_STATE from '../../../../assets/img/control-verbal-no-data.png'

const ControlVerbalOrdersComponent = () => {

    const [loading, setLoading] = useState(true);
    const [showVerifiedList, setShowVerifiedList] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [verbalOrdersListData, setVerbalOrdersListData] = useState([]);
    const [verbalOrdersVerifiedListData, setVerbalOrdersVerifiedListData] = useState([]);
    const [verbalOrderItem, setVerbalOrderItem] = useState({});
    const [selectedVerbalOrderItemIndex, setSelectedVerbalOrderItemIndex] = useState(0);
    const [showEmptyState, setShowEmptyState] = useState(false);

    useEffect(() => {
        getControlVerbalOrders();
    }, [])

    const getControlVerbalOrders = async () => {
        try {
            const reponseData = await clarificationsService.getVerbalOrders();
            if (!reponseData || reponseData.length === 0) {
                setShowEmptyState(true);
                setLoading(false);
                return;
            }
            const submittedArray = reponseData.filter(responseObject => responseObject.is_submitted === "T");
            const unsubmittedArray = reponseData.filter(responseObject => responseObject.is_submitted === "F");
            if (unsubmittedArray.length <= 0) {
                setShowEmptyState(true);
            }
            setVerbalOrdersVerifiedListData(submittedArray)
            setVerbalOrdersListData(unsubmittedArray);
            setVerbalOrderItem(unsubmittedArray[0] || {});
            setSelectedVerbalOrderItemIndex(0);
        } catch (error) {
            const { hide } = cogoToast.error(
                "Error getting Controlled Substances Data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
        setLoading(false);
    }

    const handleOnClarificationClick = (item, index) => {
        setVerbalOrderItem(item);
        setSelectedVerbalOrderItemIndex(index);
    }

    const handleOnSubmitClick = async (item) => {
        setLoading(true);
        setIsSubmitting(true);
        try {
            await clarificationsService.submitVerbalOrders(item);
            await getControlVerbalOrders();
        } catch (error) {
            const { hide } = cogoToast.error(
                "Error submitting Controlled Substances Data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
        setLoading(false);
        setIsSubmitting(false);
    }

    return (
        <>
            <div className="h-full mt-0 border-2 rounded-2xl rounded-tl-none overflow-hidden pb-16">
                <div
                    className={`inline-block customtop absolute ${loading ? "show" : "hidden"
                        }`}
                >
                    <Loader
                        type="Oval"
                        color="#00BFFF"
                        height={50}
                        width={50}
                        timeout={300000}
                    />
                </div>
                <div className="w-full h-16 flex flex-row">
                    <div
                        className={`w-1/2 text-white items-center justify-center flex border-r-2 bg-clarifications_sub
                        ${showVerifiedList ? 'bg-opacity-50' : 'bg-opacity-100'}`}
                        onClick={() => {
                            setShowVerifiedList(false);
                        }}
                    >
                        <label className="text-xs md:text-sm ml-1">Action Required</label>
                    </div>
                    <div
                        className={`w-1/2 text-white items-center justify-center flex bg-clarifications_sub
                            rounded-tr-xl ${showVerifiedList ? 'bg-opacity-100' : 'bg-opacity-50'}`}
                        onClick={() => {
                            setShowVerifiedList(true);
                        }}
                    >
                        <label className="text-xs md:text-sm ml-1">Completed</label>
                    </div>
                </div>

                {!showVerifiedList && (
                    <div className="mt-0 flex flex-row gap-4 w-full h-full p-4 mb-4 overflow-hidden justify-center">
                        {verbalOrdersListData.length > 0 && !showEmptyState && (
                            <>
                                <div className="flex flex-col lg:flex-row w-2/5 h-full overflow-scroll">
                                    <div className="w-full">
                                        <ListViewComponent
                                            list={verbalOrdersListData}
                                            onListItemClick={handleOnClarificationClick}
                                            selectedIndex={selectedVerbalOrderItemIndex}
                                        />
                                    </div>
                                </div>

                                <div className="w-full lg:w-2/3 bg-white rounded-2xl shadow-2xl h-full overflow-scroll">
                                    <VerbalOrderDetailItemComponent
                                        verbalOrderItem={verbalOrderItem}
                                        isSubmitting={isSubmitting}
                                        onSubmitClick={handleOnSubmitClick}
                                    />
                                </div>
                            </>
                        )}

                        {showEmptyState && (
                            <div className="flex flex-col gap-0 justify-center items-center">
                                <div className="w-80 h-80">
                                    <img
                                        src={VERBAL_ORDERS_EMPTY_STATE}
                                        className=""
                                        alt="no-data"
                                    />

                                </div>
                                <label className="text-lg">No Control Substances to show</label>
                            </div>
                        )}
                    </div>
                )}

                {showVerifiedList && (
                    <>
                        {verbalOrdersVerifiedListData.length > 0 ? (
                            <div className="flex overflow-scroll bg-white h-full">
                                <VerifiedVerbalOrderListComponent verbalOrderList={verbalOrdersVerifiedListData} />
                            </div>
                        ) : (
                            <div className="mt-0 flex flex-row w-full h-full p-4 mb-4 overflow-hidden justify-center">
                                <div className="flex flex-col gap-0 justify-center items-center">
                                    <div className="w-80 h-80">
                                        <img
                                            src={VERBAL_ORDERS_EMPTY_STATE}
                                            className=""
                                            alt="no-data"
                                        />

                                    </div>
                                    <label className="text-lg">No Completed Control Substances to show</label>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div >


        </>
    )

}

export default ControlVerbalOrdersComponent;